export default "__VITE_ASSET__BxVzNi4t__"